module.exports = __webpack_public_path__ + "media/images/icon/ico_datepicker_calendar-d274eb57d8aa46bd3d78f8d09bbb29cb.png";